module.exports = __webpack_public_path__ + "img/programs_carousel.44b4b6a5.png";